__turbopack_context__.v({
  "abSuggestions": "Button-module__5fJ8PG__abSuggestions",
  "alertError": "Button-module__5fJ8PG__alertError",
  "alertInformation": "Button-module__5fJ8PG__alertInformation",
  "alertSuccess": "Button-module__5fJ8PG__alertSuccess",
  "alertWarning": "Button-module__5fJ8PG__alertWarning",
  "button": "Button-module__5fJ8PG__button",
  "fullWidth": "Button-module__5fJ8PG__fullWidth",
  "hasSubLabel": "Button-module__5fJ8PG__hasSubLabel",
  "icon": "Button-module__5fJ8PG__icon",
  "iconLeft": "Button-module__5fJ8PG__iconLeft",
  "iconOnly": "Button-module__5fJ8PG__iconOnly",
  "iconRight": "Button-module__5fJ8PG__iconRight",
  "isDisabled": "Button-module__5fJ8PG__isDisabled",
  "isReversed": "Button-module__5fJ8PG__isReversed",
  "primary": "Button-module__5fJ8PG__primary",
  "secondary": "Button-module__5fJ8PG__secondary",
  "secondaryFilled": "Button-module__5fJ8PG__secondaryFilled",
  "subLabel": "Button-module__5fJ8PG__subLabel",
  "tertiary": "Button-module__5fJ8PG__tertiary",
  "text": "Button-module__5fJ8PG__text",
});
